import { render, staticRenderFns } from "./SearchChatMessages.vue?vue&type=template&id=ce5d5274&scoped=true&lang=pug"
import script from "./SearchChatMessages.vue?vue&type=script&lang=js"
export * from "./SearchChatMessages.vue?vue&type=script&lang=js"
import style0 from "./SearchChatMessages.vue?vue&type=style&index=0&id=ce5d5274&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5d5274",
  null
  
)

export default component.exports